var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.608521,
    y: 0.425293,
    width: 21.6031,
    height: 21.6031,
    rx: 10.8016,
    fill: "#59975C",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4101 15.7636C8.90924 15.7636 6.87342 13.7278 6.87342 11.227C6.87342 8.72614 8.90924 6.69032 11.4101 6.69032C13.9109 6.69032 15.9467 8.72614 15.9467 11.227C15.9467 13.7278 13.9109 15.7636 11.4101 15.7636ZM11.4101 5.55615C10.6654 5.55615 9.92796 5.70283 9.23995 5.98782C8.55193 6.2728 7.92679 6.69051 7.4002 7.2171C6.33672 8.28058 5.73926 9.72298 5.73926 11.227C5.73926 12.731 6.33672 14.1734 7.4002 15.2368C7.92679 15.7634 8.55193 16.1811 9.23995 16.4661C9.92796 16.7511 10.6654 16.8978 11.4101 16.8978C12.9141 16.8978 14.3565 16.3003 15.4199 15.2368C16.4834 14.1734 17.0809 12.731 17.0809 11.227C17.0809 10.4823 16.9342 9.74486 16.6492 9.05684C16.3642 8.36883 15.9465 7.74368 15.4199 7.2171C14.8934 6.69051 14.2682 6.2728 13.5802 5.98782C12.8922 5.70283 12.1548 5.55615 11.4101 5.55615ZM11.9772 8.39156H10.843V10.6599H8.57467V11.7941H10.843V14.0624H11.9772V11.7941H14.2455V10.6599H11.9772V8.39156Z",
    fill: "#59975C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdded);
export default __webpack_public_path__ + "static/media/added.523a799807e227e08655b014eea08e13.svg";
export { ForwardRef as ReactComponent };